import { gql } from '@apollo/client';
import InspectionFields from 'queries/inspection/inspection_fields_fragment';

export default gql`
  query inspection($id: ID!) {
    space {
      adminRole
      inspectorRole
    }
    inspection(id: $id) {
      ...InspectionFields
      notes
      relatedInspectionsTotal
      inspector {
        id
        name
        surname
        email
      }
      nextInspection {
        id
        name
        number
        place {
          id
        }
        inspectionSubject {
          id
        }
      }
      previousInspection {
        id
        name
        number
        place {
          id
        }
        inspectionSubject {
          id
        }
      }
      inspectionFields {
        id
        name
        value
        templateFieldId
      }
      externalFiles {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
      place {
        id
        name
        street
        city
        zipCode
      }
      inspectionSubject {
        id
        name
        serialNumber
        place {
          id
        }
      }
    }
  }
  ${InspectionFields}
`;
